module.exports = __webpack_public_path__ + "static/media/LevelEnd.c8d581f3.mp3";